// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Duplicate warning panels ────────────────────────────────────── */

.dup-panel {
  border-radius: 8px;
  padding: 0.875rem 1rem;
  margin-bottom: 1rem;
}

.dup-panel--conflict {
  background: #fef2f2;
  border: 1px solid #fecaca;
}

.dup-panel--soft {
  background: #fffbeb;
  border: 1px solid #fde68a;
}

.dup-panel-heading {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.375rem;
}

.dup-panel-icon {
  font-size: 1rem;
  line-height: 1;
}

.dup-panel--conflict .dup-panel-icon { color: #dc2626; }
.dup-panel--soft    .dup-panel-icon { color: #d97706; }

.dup-panel-title {
  font-size: 0.875rem;
  font-weight: 600;
}

.dup-panel--conflict .dup-panel-title { color: #991b1b; }
.dup-panel--soft    .dup-panel-title { color: #92400e; }

.dup-panel-body {
  font-size: 0.8rem;
  margin-bottom: 0.625rem;
}

.dup-panel--conflict .dup-panel-body { color: #b91c1c; }
.dup-panel--soft    .dup-panel-body { color: #a16207; }

/* ── Match cards ─────────────────────────────────────────────────── */

.dup-match-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.dup-match-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: #fff;
  border-radius: 6px;
  padding: 0.625rem 0.75rem;
}

.dup-panel--conflict .dup-match-card { border: 1px solid #fecaca; }
.dup-panel--soft    .dup-match-card { border: 1px solid #fde68a; }

.dup-match-avatar {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #d1fae5;
  color: #065f46;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.dup-match-info {
  flex: 1;
  min-width: 0;
}

.dup-match-name {
  font-size: 0.9375rem;
  font-weight: 500;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dup-match-meta {
  font-size: 0.8rem;
  color: #6b7280;
  margin-top: 0.1rem;
}

.dup-dot {
  margin: 0 0.25em;
  color: #d1d5db;
}

.dup-match-ids {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-top: 0.25rem;
}

.dup-id-tag {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.1rem 0.4rem;
  border-radius: 4px;
  background: #f3f4f6;
  color: #374151;
}

.dup-match-reason {
  font-size: 0.7rem;
  color: #dc2626;
  margin-top: 0.2rem;
  font-style: italic;
}

.dup-use-btn {
  flex-shrink: 0;
  white-space: nowrap;
  font-size: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/horses/modal-add-horse/modal-add-horse.component.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,uCAAuC,cAAc,EAAE;AACvD,sCAAsC,cAAc,EAAE;;AAEtD;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,wCAAwC,cAAc,EAAE;AACxD,uCAAuC,cAAc,EAAE;;AAEvD;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,uCAAuC,cAAc,EAAE;AACvD,sCAAsC,cAAc,EAAE;;AAEtD,uEAAuE;;AAEvE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,uCAAuC,yBAAyB,EAAE;AAClE,sCAAsC,yBAAyB,EAAE;;AAEjE;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":["/* ── Duplicate warning panels ────────────────────────────────────── */\n\n.dup-panel {\n  border-radius: 8px;\n  padding: 0.875rem 1rem;\n  margin-bottom: 1rem;\n}\n\n.dup-panel--conflict {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n}\n\n.dup-panel--soft {\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n}\n\n.dup-panel-heading {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.375rem;\n}\n\n.dup-panel-icon {\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.dup-panel--conflict .dup-panel-icon { color: #dc2626; }\n.dup-panel--soft    .dup-panel-icon { color: #d97706; }\n\n.dup-panel-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.dup-panel--conflict .dup-panel-title { color: #991b1b; }\n.dup-panel--soft    .dup-panel-title { color: #92400e; }\n\n.dup-panel-body {\n  font-size: 0.8rem;\n  margin-bottom: 0.625rem;\n}\n\n.dup-panel--conflict .dup-panel-body { color: #b91c1c; }\n.dup-panel--soft    .dup-panel-body { color: #a16207; }\n\n/* ── Match cards ─────────────────────────────────────────────────── */\n\n.dup-match-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.dup-match-card {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: #fff;\n  border-radius: 6px;\n  padding: 0.625rem 0.75rem;\n}\n\n.dup-panel--conflict .dup-match-card { border: 1px solid #fecaca; }\n.dup-panel--soft    .dup-match-card { border: 1px solid #fde68a; }\n\n.dup-match-avatar {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #d1fae5;\n  color: #065f46;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.dup-match-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.dup-match-name {\n  font-size: 0.9375rem;\n  font-weight: 500;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dup-match-meta {\n  font-size: 0.8rem;\n  color: #6b7280;\n  margin-top: 0.1rem;\n}\n\n.dup-dot {\n  margin: 0 0.25em;\n  color: #d1d5db;\n}\n\n.dup-match-ids {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  margin-top: 0.25rem;\n}\n\n.dup-id-tag {\n  font-size: 0.7rem;\n  font-weight: 600;\n  padding: 0.1rem 0.4rem;\n  border-radius: 4px;\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.dup-match-reason {\n  font-size: 0.7rem;\n  color: #dc2626;\n  margin-top: 0.2rem;\n  font-style: italic;\n}\n\n.dup-use-btn {\n  flex-shrink: 0;\n  white-space: nowrap;\n  font-size: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
